const styles = theme => ({
  container: {
    marginBottom: '24px',
    // border: '1px solid ' + theme.palette.background.border,
    borderRadius: '0px',
    backgroundColor: 'transparent',
  },
  accordion: {
    width: '100%',
    // backgroundColor: theme.palette.background.primary,
    backgroundColor: 'transparent',
    borderRadius: '0px',
  },
  divider: {
    margin: '0 30px',
  },
});

export default styles;
